// src/pages/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../firebaseConfig";
import toast from "react-hot-toast";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check if profile exists in Firestore
      const profileRef = doc(db, "users", user.uid);
      const snapshot = await getDoc(profileRef);

      if (snapshot.exists()) {
        navigate("/profile"); // Profile found
      } else {
        navigate("/profile-setup"); // No profile yet
      }
    } catch (err) {
      let msg;
      if (err.code === "auth/user-not-found") {
        msg = "No account found with this email. Please sign up first.";
      } else if (err.code === "auth/wrong-password") {
        msg = "Incorrect password. Try again.";
      } else {
        msg = "Login failed. " + err.message;
      }
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <form onSubmit={handleLogin} className="bg-white p-6 rounded-lg shadow-md w-80 space-y-4">
        <h2 className="text-2xl font-bold text-center">Login</h2>

        {error && <p className="text-red-500 text-sm">{error}</p>}

        <input
          type="email"
          placeholder="Email"
          className="w-full p-2 border rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          className="w-full p-2 border rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="w-full bg-brand text-black font-semibold py-2 rounded">
          Login
        </button>

        <p className="text-sm text-center text-gray-600">
          Don’t have an account?{" "}
          <Link to="/register" className="text-brand hover:underline font-medium">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
}
